import axios from 'axios'
import md5 from 'md5'
import qs from 'qs'
import { apiClientHeader } from "./apiClientHeader"
import updateApiClientHeader from './updateApiClientHeader'

import { goToLogin } from './redirect'
export const apiClient = function(option) {
  // 判断是否需要跳转登录
  const needLogin = option.hasOwnProperty('needLogin') ? option.needLogin : true
  // 判断responseType
  const responseType = option.hasOwnProperty('responseType') ? option.responseType : 'json'
  option.header && Object.getOwnPropertyNames(option.header).length > 0 && updateApiClientHeader(option.header)

  const service = axios.create({
    timeout: 60000, // request timeout
    withCredentials: true,
    responseType: responseType
  })
  
  /* 对象属性 */
  const objectConvert = obj => {
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] == "undefined") {
            delete obj[key]
        }
      })
      const split_str = "{#_#}"
      return qs.parse(qs.stringify(obj, { delimiter: split_str }).split(split_str).sort().join(split_str), {
          delimiter: split_str,
      })
  }

  let host = 'm'
  let env = ''

  const getBaseUrl = (config, url) => {
    if (url.indexOf("http") === 0) return url
    env = option.env ? option.env : ''
    host = config.host ? config.host : (option.host ? option.host : 'm')
    let inc = 'inc'
    if ((host === 'm' && !env) || env == 'pre') {
      inc = ''
    }
    return `https://${env}${config.headers.apiShow == false ? '' : 'api'}${host}.modian${inc}.com${url}`
  }
  service.interceptors.request.use(
    config => {
      const appkey = 'MzgxOTg3ZDMZTgxO'
      /* 处理请求头参数 */
      if(apiClientHeader) {
        for(let key in apiClientHeader) {
          config.headers[key] = config.headers[key] ? config.headers[key] : apiClientHeader[key]
        }
      }
      if (config.header) {
        for(let key in config.header) {
          config.headers[key] = config.headers[key] ? config.headers[key] : config.header[key]
        }
      }
      /* 获取域名 */
      /** 拆解 url 与 query 参数 */
      const hostArr = config.url.indexOf('?') ? config.url.split("?") : config.url ;
      const url = hostArr[0];
      let query = hostArr[1] ? qs.parse(hostArr[1]) : {};
      config.url = getBaseUrl(config, url)
      const hosts = config.url.replace("http://", "").replace("https://", "")
      /* 获取时间戳 */
      const timestamp = Date.parse(new Date()) / 1000;
      config.headers.mt = timestamp

      /** 格式化传入参数 */
      let props = config.props || {};

      /* props 转换格式并排序 */
      let query_data, props_data
      if ("get" === config.method) { 
        Object.assign(query, props)
        query_data = qs.stringify(objectConvert(query), { encode: false })
        props = ""
      } else {
          if(config.headers['Content-Type'] === 'multipart/form-data'){
          query_data = ""
          props_data = props
          props = ""
        }else{
          query_data = ""
          props_data = qs.stringify(objectConvert(props))
          props = qs.stringify(objectConvert(props), { encode: false })
        }
      }
      config.params = query
      config.data = props_data

      /* 生成 sign 算法 */
      config.headers.sign = md5(hosts + appkey + timestamp + query_data + md5(props));
      
      return config
    },
    error => {
      if (option.callback && typeof option.callback === 'object') {
        option.callback(error)
      }
      return Promise.reject(error)
    }
  )
  
  service.interceptors.response.use(
    response => {
      const { data } = response
      const { status } = data
      if (((status === 10000 || (status == 1 && data.data == 10000)) && !needLogin)) {  
        goToLogin(host, env)
      } else {
        return Promise.resolve(data)
      }
  },
    error => {
      console.log('[ERROR]', error)
      return Promise.resolve({
        status: '999999'
      })
    }
  )
  return service
}
// 域名
export const apiHost = {
  ACP: 'acp',
  M: 'm',
}
